/** Sync-licensing usage types — what a track can be licensed FOR, and what a
 *  buyer picks in a licence inquiry. (Gordon 2026-07-14.) */
export const SYNC_USAGE_TYPES = [
  "Film",
  "Series",
  "Documentary",
  "Commercial",
  "Game",
  "TV Show",
  "Radio ID",
] as const;

export type SyncUsageType = (typeof SYNC_USAGE_TYPES)[number];
